import request from '@/utils/request';

export function getAppStyle() {
  return request({
    url: '/Common/getAppStyle',
    silentRequest: true,
  });
}

export function informMe(targetId, targetType) {
  return request({
    url: '/Common/informMe',
    method: 'POST',
    data: {
      targetId,
      targetType,
    },
  });
}

export function commonLog(type, params) {
  return request({
    url: '/Common/log',
    method: 'POST',
    data: {
      type,
      params,
    },
    silentRequest: true,
  });
}

export function getWechatConfig(url, configAccount = 'default') {
  return request({
    url: '/Common/wechatConfig',
    params: {
      configUrl: url,
      configAccount,
    },
    silentRequest: true,
  });
}

export function getUploadParams(fileName, category = 'default') {
  return request({
    url: '/Common/getOssUploadParams',
    method: 'POST',
    data: {
      category,
      fileName,
    },
  });
}

export function uploadFile(data, baseUrl) {
  return request({
    baseUrl,
    url: '/',
    method: 'POST',
    data,
    multipartFormData: true,
  });
}

export function checkRegionJsonVersion() {
  return request({
    url: '/Common/checkRegionJsonVersion',
  });
}

export function getRegionDataURL() {
  return request({
    url: '/Common/getRegionJsonUrl',
  });
}

export function getRegionData(baseUrl) {
  return new Promise(async (resolve, reject) => {
    try {
      await request({
        baseUrl,
      });
      return reject();
    } catch (data) {
      const { city_list: cityList, county_list: countyList, province_list: provinceList } = data;
      if (cityList && countyList && provinceList) {
        return resolve(data);
      }
    }
    return reject();
  });
}

export function getEventLogConfig() {
  return request({
    url: '/Common/getEventLogConfig',
    silentRequest: true,
  });
}

export function getAppRouteMap() {
  return request({
    url: '/Common/getAppRouteMap',
    silentRequest: true,
  });
}

export function getActivityPopupInfo() {
  return request({
    url: '/Common/activityPopupInfo',
    silentRequest: true,
  });
}

export function getProductFilterInfo(params) {
  return request({
    url: '/Common/productFilter',
    params,
    silentRequest: true,
  });
}

export function getStaticShareInfo(params) {
  return request({
    url: '/Common/getStaticShareInfo',
    params,
    silentRequest: true,
  });
}

export function getWeChatUserInfo(redirectTo) {
  return request({
    url: '/User/getInfoWeChatUrl',
    params: {
      redirectTo,
    },
    silentRequest: true,
  });
}

export function getDownloadBarInfo() {
  return request({
    url: '/Common/getDownloadBarInfo',
    silentRequest: true,
  });
}

export function getCaptchaInfo() {
  return request({
    url: '/Common/captcha',
  });
}

export function getCustomerServiceInfo(targetId, targetType) {
  return request({
    url: '/Common/consultInfo',
    params: {
      targetId,
      targetType,
    },
  });
}

export function getAgencyPageList() {
  return request({
    url: '/Common/getAgencyPageList',
    silentRequest: true,
  });
}

export function getAgencySettingBarInfo(productId, productType) {
  return request({
    url: '/Common/getAgencySetting',
    params: {
      id: productId,
      type: productType,
    },
    silentRequest: true,
  });
}

export function getProductWeChatGroupInfo(params) {
  return request({
    url: '/Common/getWeChatGroupInfo',
    params,
    silentRequest: true,
  });
}

export function recordJoinWeChatGroup(id, type) {
  return request({
    url: '/Common/recordJoinWeChatGroup',
    params: {
      id,
      type,
    },
  });
}

export function loginRegisterWithMobile(data) {
  return request({
    url: '/User/loginRegisterWithMobile',
    method: 'POST',
    data,
  });
}

export function getCommonCouponPopupInfo(pageName) {
  return request({
    url: '/Common/couponPopupInfo',
    params: {
      pageName,
    },
    silentRequest: true,
  });
}
